$.extend(window.BetSlipUtil, (function ()
{
    var api = { };   
    var uniSlip = getUniSlip();    

    function getUniSlip() {
        uniSlip = uniSlip || (typeof BetSlip !== 'undefined' ? BetSlip : undefined);
		return uniSlip;
    }

    //Lines.js(Mobile) - isInSlip
    /* jshint maxparams: 4 */
    var isInSlip = function (meID, evID, lgID, id)
    {
        var i = uniSlip.Selections.length, item;

        while (i > 0)
        {
            i -= 1;
            item = uniSlip.Selections[i];
            // when bet comes from Open Bets it has BetID and we need to skip it
            if (!item || item.BetID)
            {
                continue;
            }

            if (item.LineID == id && item.LineGroupID == lgID && item.EventID == evID && item.MasterEventID == meID)
            {
                return true;
            }
        }

        return false;
    };
    /* jshint maxparams: 3 */

    //Lines.js(Mobile) - isLiveInSlip
    /* jshint maxparams: 5 */ // TODO: Refactor to reduce number of params!
    var isLiveInSlip = function (meID, evID, lgID, side, betTypeID)
    {
        var i = uniSlip.Selections.length, item;

        while (i > 0)
        {
            i -= 1;
            item = uniSlip.Selections[i];
            // when bet comes from Open Bets it has BetID and we need to skip it
            if (!item || item.BetID)
            {
                continue;
            }

            if (item.LineGroupID == lgID &&
                item.EventID == evID &&
                item.MasterEventID == meID &&
                item.BetSide == side &&
                item.BetTypeID == betTypeID)
            {
                return true;
            }
        }

        return false;
    };
    /* jshint maxparams: 3 */

    // QAEventInfo.js(Mobile) - isQAInSlip
    var isQAInSlip = function (masterEventID, eventID, lineID)
    {
        var i = uniSlip.Selections.length, item;

        while (i > 0)
        {
            i -= 1;
            item = uniSlip.Selections[i];
            // when bet comes from Open Bets it has BetID and we need to skip it
            if (!item || item.BetID)
            {
                continue;
            }

            if (item.LineID == lineID && item.EventID == eventID && item.MasterEventID == masterEventID)
            {
                return true;
            }
        }

        return false;
    };

    //QALine.js(Mobile) - isLiveQAInSlip
    var isLiveQAInSlip = function (meID, evtID, lineID)
    {
        var i = uniSlip.Selections.length, item;

        while (i > 0)
        {
            i -= 1;
            item = uniSlip.Selections[i];
            // when bet comes from Open Bets it has BetID and we need to skip it
            if (!item || item.BetID)
            {
                continue;
            }

            if (item.MasterEventID == meID && item.EventID == evtID && item.LineID == lineID)
            {
                return true;
            }
        }

        return false;
    };

    /* jshint maxparams: 13 */ // TODO: Refactor to reduce number of params!
    api.addOddLive = function (masterEventID, eventID, LineGroupID, litetypeid, rowtypeid, Odds, Points, lineID, eventTypeId, isFavTeam, leagueId, betId)
    {
        var liveSelection = new RegularLiveSlipSelection(masterEventID, eventID, LineGroupID, litetypeid, rowtypeid, Odds, Points, 0, 0, null, eventTypeId, isFavTeam, leagueId);
        liveSelection.LineID = lineID || 0;
        liveSelection.BetID = betId;
        BetSlip.add(liveSelection);
        return liveSelection;
    };

    /* jshint maxparams: 13 */ // TODO: Refactor to reduce number of params!
    api.addOddRegular = function(masterEventID, eventID, LineGroupID, litetypeid, rowtypeid, Odds, Points, lineId, eventTypeId, favTeam, isPreloaded, leagueId, betId)
    {
        var selObj = new RegularSlipSelection(masterEventID, eventID, LineGroupID, lineId, Odds, Points, eventTypeId, favTeam, leagueId);
        selObj.BetTypeID = litetypeid;
        selObj.BetSide = rowtypeid;
        selObj.BetID = betId;
        BetSlip.add(selObj, isPreloaded);
    };

    api.addOddQALive = function (masterEventID, eventID, lineID, Odds, eventTypeId, isPreloaded, leagueId, betId)
    {
        var selObj = new QALiveSlipSelection(masterEventID, eventID, lineID, Odds, 0, 0, eventTypeId, leagueId);
        selObj.BetID = betId;
        BetSlip.add(selObj, isPreloaded);
    }

    api.addOddQARegular = function (masterEventID, eventID, lineID, Odds, eventTypeId, isPreloaded, leagueId, betId)
    {
        var selObj = new QASlipSelection(masterEventID, eventID, lineID, Odds, eventTypeId, leagueId);
        selObj.BetID = betId;
        BetSlip.add(selObj, isPreloaded);
    }

    /* jshint maxparams: 3 */

    api.addQAInitilizedSelectionToBetSlip = function (data)
    {
        var previousModeID = BetSlip.CurrentMode.ID;
        for (var i = 0; i < data.lines.length; i += 1)
        {
            var item = data.lines[i];
            BetSlip.selectSlipMode("pulse");
            var selection = new QALiveSlipSelection(item.masterEventId, item.eventId, item.lineId, item.odds, item.score1, item.score2, item.eventTypeId, item.leagueId);
            selection.processBetUpdate({
                BranchID: item.branchId,
                BranchName: item.branchName,
                LeagueID: item.leagueId,
                EventTypeID: item.eventTypeId,
                EventTypeName: item.eventTypeName,
                OppositeEventTypeID: item.oppositeEventTypeId,
                EventName: item.eventName,
                Team1Name: item.team1Name,
                Team2Name: item.team2Name,
                LiveGroupID: item.liveGroupId,
                PreLiveGroupID: item.preLiveGroupId,
                maxBet: item.maxBet,
                minBet: item.minBet,
                waitingAllowed: item.waitingAllowed,
                MaxBetCombo: item.maxBetCombo,
                MaxBetSystem: item.maxBetSystem,
                MaxBetTeaser: item.maxBetTeaser,
                MaxRisk: item.maxRisk,
                MaxRiskCombo: item.maxRiskCombo,
                MaxRiskSystem: item.maxRiskSystem,
                MaxRiskTeaser: item.maxRiskTeaser,
                MaxRiskComboEachWay: item.maxRiskComboEachWay,
                MaxStakeComboEachWay: item.maxStakeComboEachWay,
                SingleSelectionRisk: item.singleSelectionRisk,
                RealOrPresumptiveOdds: item.realOrPresumptiveOdds,
                MaxBetForCustomer: item.maxBetForCustomer,
                SingleBetIsEnabled: item.singleBetIsEnabled,
                ComboBetIsEnabled: item.comboBetIsEnabled,
                SystemBetIsEnabled: item.systemBetIsEnabled,
                TeaserBetIsEnabled: item.teaserBetIsEnabled,
                IsTeamSwapEnabled: item.isTeamSwapEnabled,
                LineTypeName: item.lineTypeName,
                EventDate: item.eventDate,
                BetTypeID: item.betTypeId,
                LineTypeID: item.lineTypeId,
                UseEventName: item.useEventName,
                LineName: item.LineName,
                AsianLineName: item.asianLineName,
                MappedLineTypeID: item.mappedLineTypeId,
                Swapped: item.swapped,
                SplitType: item.splitTypeId,
                SISEventID: item.SISEventId,
                GBSEventID: item.GBSEventId,
                FeedEventID: item.feedEventId,
                FeedProviderID: item.feedProviderId,
                QAParameter1:item.qaParameter1,
                QAParameter2: item.qaParameter2, 
                HasGameStarted: true
            });
            selection.ViewKey = BetSlip.getViewKey();
            BetSlip.Selections[selection.ViewKey] = selection;
        }
        BetSlip.CurrentMode.Deposit = data.stake;
        BetSlip.CurrentMode.placeBets(item.eventTypeId);
        BetSlip.selectSlipMode(previousModeID);
    };

    api.getAvailableFreeBetsForPulse = function (data)
    {
        var pulseBetEvent = {
            HasGameStarted: true,
            BranchID: data.branchId,
            LeagueID: data.leagueId,
            EventTypeID: data.typeId,
            Live: true,
            MasterEventID: data.masterEventId,
            BetType: 25,        //Bet type 25 is Pulse bet
            Odds: data.odds
        }

        return BetSlip.Modes["pulse"] && BetSlip.Modes["pulse"].getAvailableFreeBets(pulseBetEvent, false);
    };

    api.removeAllSelectedFreePulseBets = function ()
    {
        BetSlip.Modes["pulse"] && BetSlip.Modes["pulse"].removeAllSelectedFreePulseBets();
    };
    
    /*globals addQAOdd, addOdd */
    /* jshint maxcomplexity: 6, maxparams: 14 */ // TODO: Refactor to reduce complexity!
    api.addOddToSlip = function (masterEventID, eventID, lineID, odds, lineGroupID, lineTypeID, rowTypeID, points, isLive, isQA, eventTypeId, leagueId, betId, preventUpdating, isFavedTeam)
    {
        var isPreloaded = BetSlip.IsInEditMode || preventUpdating;
        if (!getUniSlip())
        {
            return false;
        }

        if (isLive)
        {
            if (isQA)
            {
                // masterEventID - LiveMasterEvent.ID, eventID - LiveQAEventInfo.ID, lineID - QALine.ID, Odds - QALine.Odds
                return addOddQALive(masterEventID, eventID, lineID, odds, eventTypeId, isPreloaded, leagueId, betId);
            }
            else
            {
                /* masterEventID - LiveMasterEvent.ID or LiveEventInfo.MasterEventID(in Mobile); eventID - LiveEventInfo.ID; 
                   lineGroupID - LineGroup.ID; lineTypeID - hard-coded values of MLOdds(HCOdds or OUOdds).BetType;
                   rowTypeID - 1(Team 1), 2(Draw) or 3(Team 2);
                   odds - MLOdds(HCOdds or OUOdds)-> ML1_Odds, ML2_Odds or ML3_Odds(Odds1 or Odds3);
                   points - positive or negative values of MLOdds(HCOdds or OUOdds).Points1 */
                return api.addOddLive(masterEventID, eventID, lineGroupID, lineTypeID, rowTypeID, odds, points, lineID, eventTypeId, isFavedTeam, leagueId, betId);
            }
        }
        else
        {
            if (isQA)
            {
                // masterEventID - MasterEvent.ID, eventID - QAEventInfo.ID, lineID - QALine.ID, odds - QALine.Odds
                return addQAOdd(masterEventID, eventID, lineID, odds, eventTypeId, isPreloaded, leagueId, betId);
            }
            else
            {
                /* masterEventID - MasterEvent.ID; eventID - EventInfo.ID, lineGroupID - LineGroup.ID;
                   lineID - MLOdds(HCOdds, OUOdds)-> ML1_ID, ML2_ID or ML3_ID(ID1 or ID3); 
                   odds - MLOdds(HCOdds or OUOdds)-> ML1_Odds, ML2_Odds or ML3_Odds(Odds1 or Odds3);
                   points - positive or negative values of MLOdds(HCOdds or OUOdds).Points1 */
                return addOdd(masterEventID, eventID, lineGroupID, lineID, odds, points, eventTypeId, isFavedTeam, isPreloaded, leagueId, betId);
            }
        }
    };
    /* jshint maxcomplexity: 5, maxparams: 3 */

    /* jshint maxcomplexity: 6 */ // TODO: Refactor to reduce complexity!
    /* jshint maxparams: 8 */ // TODO: Refactor to reduce number of params!
    api.isOddInSlip = function (masterEventID, eventID, lineID, lineGroupID, rowTypeID, betTypeID, isLive, isQA)
    {
        if (!getUniSlip()) { return false; }

        if (isLive)
        {
            if (isQA)
            {
                // masterEventID - LiveMasterEvent.ID, eventID - LiveQAEventInfo.ID, lineID - QALine.ID
                return isLiveQAInSlip(masterEventID, eventID, lineID);
            }

            /* masterEventID - LiveMasterEvent.ID or LiveEventInfo.MasterEventID(in Mobile); eventID - LiveEventInfo.ID; 
               lineGroupID - LineGroup.ID; rowTypeID - 1(Team 1), 2(Draw) or 3(Team 2);
               betTypeID(lineTypeID) - hard-coded values of MLOdds(HCOdds or OUOdds).BetType; */
            return isLiveInSlip(masterEventID, eventID, lineGroupID, rowTypeID, betTypeID);
        }

        if (isQA)
        {
            // masterEventID - MasterEvent.ID, eventID - QAEventInfo.ID, lineID - QALine.ID
            return isQAInSlip(masterEventID, eventID, lineID);
        }

        /* masterEventID - MasterEvent.ID; eventID - EventInfo.ID, lineGroupID - LineGroup.ID;
           lineID - MLOdds(HCOdds, OUOdds)-> ML1_ID, ML2_ID or ML3_ID(ID1 or ID3); */
        return isInSlip(masterEventID, eventID, lineGroupID, lineID);
    };
    /* jshint maxparams: 3 */
    /* jshint maxcomplexity: 5 */

    /* jshint maxparams: 8 */
    api.addQAOddHR = function (masterEventID, eventID, lineID, Odds, RacingRegionID, RacingMode, eventTypeId)
    {
        /*globals QASlipSelection */
        var qaBet = new QASlipSelection(masterEventID, eventID, lineID, Odds, eventTypeId);


        qaBet.RacingRegionID = RacingRegionID;
        qaBet.RacingMode = RacingMode;

        BetSlip.add(qaBet);
    };

    api.subscribeOnSelectionRemoved = function (subscriberId, handler) {
        BetSlip.OnSelectionRemoved[subscriberId] = function (selection) {
            handler(selection.BranchID, selection.MasterEventID, selection.EventID, selection.LineID, selection.BetTypeID);
        };
    }

    api.subscribeOnSelectionAdded = function (subscriberId, handler) {
        BetSlip.OnAdd[subscriberId] = function (sender, selection) {
            handler(selection.BranchID, selection.MasterEventID, selection.EventID, selection.LineID, selection.BetTypeID);
        };
    }

    api.addMultiLineOddToSlip = function (masterEventID, eventID, lineID, Odd, variants, eventTypeId, isVirtual)
    {
        if (!getUniSlip())
        {
            return false;
        }
        /*globals addMultiLineOdd */
        addMultiLineOdd(masterEventID, eventID, lineID, Odd, variants, eventTypeId, isVirtual);
    };

    api.addPulseBet = function (masterEventID, eventID, lineID, Odds, Score1, Score2, eventTypeId, leagueId, stake)
    {
        if (!getUniSlip())
        {
            return false;
        }

        BetSlip.clear(); // it clears all selections in BetSlip before adding the pulse bet selections


        BetSlip.restoreSlipMode('pulse');
        BetSlip.CurrentMode.placeBet();

        //add selections to BetSlip
        setPulseBetSelectionAndDeposit(new QALiveSlipSelection(masterEventID, eventID, lineID, Odds, Score1, Score2, eventTypeId, leagueId), stake);
        setPulseBetSelectionAndDeposit(new QALiveSlipSelection(masterEventID, eventID, lineID, Odds, Score1, Score2, eventTypeId, leagueId), 0);
        setPulseBetSelectionAndDeposit(new QALiveSlipSelection(masterEventID, eventID, lineID, Odds, Score1, Score2, eventTypeId, leagueId), 0);
    };

    var setPulseBetSelectionAndDeposit = function (selection, deposit)
    {
        var viewKey = BetSlip.getViewKey();
        BetSlip.Selections[viewKey] = selection;
        BetSlipUtil.CurrentMode.setDeposit(viewKey, deposit);
    };

    api.getAllBetsDepositValue = function (mode)
    {
        // First we remove the undefined entries inside the deposits array
        var allBets = mode.Deposits.filter(function (n) { return n !== undefined; }),
            allBetsCount = allBets.length;

        //We need to check if there are selections that are part ot multi line but not present as singles and remove them from the bets count
        //because when adding multi lines we add the selections that make it with 0 deposit and this leeds to wrong calculations for all bets
        if (BetSlip.Selections.any(function (sel) { return sel.IsMultiLine; }))
        {
            var castSelections = Array.findAll(BetSlip.Selections, function (sel) { return sel.CastSelection && !sel.VisibleCastSelection; });
            allBetsCount = allBetsCount - Array.getLength(castSelections);
        }

        if (allBetsCount > 0)
        {
            // Here we check mathematically if all the elements are equal
            var allElementsSum = allBets.reduce(function (prev, cur) { return prev + cur; }),
                betsDelta = allElementsSum / allBetsCount;

            if (betsDelta === Math.max.apply(null, allBets))
            {
                mode.AllBetsDeposit = betsDelta;
            }
            else
            {
                mode.AllBetsDeposit = 0;
            }
        }
        else
        {
            mode.AllBetsDeposit = 0;
        }
    };
    /* jshint maxparams: 3 */


    /* jshint maxcomplexity: 5 */

    api.addQAForecastBet = function (event)
    {
        if (!event) return false;
        if (!event.canPlaceForecastBet()) return false;

        var Odd = 0; // ???
        var lineID = 0; // ???

        var foreVariants = generateCastVariants(event.ForecastSelection, event, false);
        if (foreVariants)
        {
            this.addMultiLineOddToSlip(event.MasterEventID, event.ID, lineID, Odd, foreVariants, getEventTypeId(null, event), VirtualSports.isBranchVirtual(event.BranchID));
        }

        var triVariants = generateCastVariants(event.TricastSelection, event, true);
        if (triVariants)
        {
            this.addMultiLineOddToSlip(event.MasterEventID, event.ID, lineID, Odd, triVariants, getEventTypeId(null, event), VirtualSports.isBranchVirtual(event.BranchID));
        }
        return true;
    };

    api.addExoticBet = function (event)
    {
        if (!event || !event.canPlaceExoticBet()) return false;
        var Odd = 0; // ???
        var lineID = 0; // ???
        event.buildExotic();
        var bets = event.getCurrentExoticBets();
        if (event.ExoticType == 'Quinella')
        {
            var quinellaSelection = bets[0];
            var quinellaVariants = generateCastVariants(quinellaSelection, event, false);
            if (quinellaVariants)
            {
                this.addMultiLineOddToSlip(event.MasterEventID, event.ID, lineID, Odd, quinellaVariants, getEventTypeId(null, event));
            }
        }
        else
        {
            for (var i = 0; i < bets.length; i += 1)
            {
                var bet = bets[i];
                var exoticVariants = generateExoticVariants(bet, event);
                if (exoticVariants)
                {
                    this.addMultiLineOddToSlip(event.MasterEventID, event.ID, lineID, Odd, exoticVariants, getEventTypeId(null, event));
                }
            }
        }
        return true;
    };

    var getExoticEventMaxBet = function (event)
    {
        switch (event.ExoticType)
        {
            case 'Quinella':
            case 'Exacta':
                return event.ForecastMaxBet;
            case 'Trifecta':
                return event.TricastMaxBet;
            case 'FirstFour':
                return event.FirstFourMaxBet;
        }
    };

    var generateExoticVariants = function (selection, event)
    {
        var minSelections = event.getColumnsCount();
        if (Array.getLength(selection) < minSelections)
        {
            return false;
        }
        var groupPositions = [];
        var castSelections = [];
        var cb;
        var vk;
        var groupSize = minSelections;
        var maxBet = getExoticEventMaxBet(event);
        var lines = [];
        for (var idx in selection)
        {
            lines.push(event.Lines[idx]);
        }

        lines = getSortedLines(lines, event.RacecardInfo);

        for (var i = 0; i < Array.getLength(lines) ; i += 1)
        {
            var line = lines[i];

            cb = new QASlipSelection(line.MasterEventID, event.ID, line.ID, line.Odds, getEventTypeId(null, event));
            cb.CastSelection = true;
            cb.LocationHash = location.hash;
            cb.EventDate = event.Date;
            vk = BetSlip.add(cb);

            if (vk === -1)
            {
                var sel = Array.find(BetSlip.Selections, function (el) { return el.LineID === cb.LineID || el.AlternateLineID == cb.LineID });
                if (sel)
                {
                    vk = sel.ViewKey;
                    if (!sel.CastSelection)
                    {
                        sel.CastSelection = true;
                        sel.VisibleCastSelection = true;
                    }
                }
            }

            // -2 means the selection could not be added to the BetSlip
            if (vk === -2)
            {
                for (var idx in castSelections)
                {
                    BetSlip.removeBet(castSelections[idx]);
                }

                return false;
            }

            var item = { ViewKey: vk, Position: selection[line.ID] };

            groupPositions.push(item);
            castSelections.push(vk);

            if (selection[line.ID] === 0) groupSize = -1;
        }

        var groups = generateGroups(castSelections, groupSize, groupPositions);
        for (var item in groups)
        {
            groups[item].sort(chainSort(
                function (r1, r2)
                {
                    var x = Array.find(groupPositions, function (el) { return el.ViewKey === r1 });
                    var y = Array.find(groupPositions, function (el) { return el.ViewKey === r2 });

                    if (x !== null && y !== null)
                    {
                        if (x.Position > y.Position) return 1;
                        if (x.Position < y.Position) return -1;
                        return 0;
                    }
                }));
        }
        var result = { Groups: groups, GroupPositions: groupPositions, EventDate: event.Date, MaxBet: maxBet, IsTriCast: false, PositionsCount: minSelections };
        return result;
    };


    /* jshint maxcomplexity: 5 */
    var generateCastVariants = function (selection, event, isTriCast)
    {
        var minSelections = (isTriCast ? 3 : 2);
        if (Array.getLength(selection) < minSelections)
        {
            return false;
        }

        var groupPositions = [];
        var castSelections = [];
        var cb;
        var vk;
        var groupSize = 2;
        var maxBet = event.ForecastMaxBet;
        if (isTriCast)
        {
            groupSize = 3;
            maxBet = event.TricastMaxBet;
        }

        var lines = [];
        for (var idx in selection)
        {
            lines.push(event.Lines[idx]);
        }

        lines = getSortedLines(lines, event.RacecardInfo);

        for (var i = 0; i < Array.getLength(lines) ; i += 1)
        {
            var line = lines[i];

            cb = new QASlipSelection(line.MasterEventID, event.ID, line.ID, line.Odds, getEventTypeId(null, event));
            cb.CastSelection = true;
            cb.LocationHash = location.hash;
            cb.EventDate = event.Date;
            vk = BetSlip.add(cb);

            if (vk === -1)
            {
                var sel = Array.find(BetSlip.Selections, function (el) { return el.LineID === cb.LineID || el.AlternateLineID == cb.LineID });
                if (sel)
                {
                    vk = sel.ViewKey;
                    if (!sel.CastSelection)
                    {
                        sel.CastSelection = true;
                        sel.VisibleCastSelection = true;
                    }
                }
            }

            // -2 means the selection could not be added to the BetSlip
            if (vk === -2)
            {
                for (var idx in castSelections)
                {
                    BetSlip.removeBet(castSelections[idx]);
                }

                return false;
            }

            var item = { ViewKey: vk, Position: selection[line.ID] };

            groupPositions.push(item);
            castSelections.push(vk);

            if (selection[line.ID] === 0) groupSize = -1;
        }

        var groups = generateGroups(castSelections, groupSize, groupPositions);
        for (var item in groups)
        {
            groups[item].sort(chainSort(
                function (r1, r2)
                {
                    var x = Array.find(groupPositions, function (el) { return el.ViewKey === r1 });
                    var y = Array.find(groupPositions, function (el) { return el.ViewKey === r2 });

                    if (x != null && y != null)
                    {
                        if (x.Position > y.Position) return 1;
                        if (x.Position < y.Position) return -1;
                        return 0;
                    }
                }));
        }

        var result = { Groups: groups, GroupPositions: groupPositions, EventDate: event.Date, MaxBet: maxBet, IsTriCast: isTriCast };
        return result;
    };

    /* jshint maxcomplexity: 5 */
    var generateGroups = function (in_group, groupSize, groupPosition)
    {
        var subGroups = [];
        if (groupSize == -1)
        {
            subGroups.push(in_group);
            return subGroups;
        } else if (groupSize == 1)
        {
            for (var groupElemKey in in_group)
            {
                subGroups.push([in_group[groupElemKey]]);
            }
        } else
        {
            for (var i = 0; i < in_group.length; i += 1)
            {
                var tmpGroups = generateGroups(in_group.slice(i + 1), groupSize - 1, groupPosition);

                for (var j in tmpGroups)
                {
                    var tmpGroup = tmpGroups[j];
                    var z = Array.find(tmpGroup, function (el) { return el == in_group[i] });
                    if (z == null)
                    {
                        var c = Array.find(groupPosition, function (el) { return el.ViewKey == in_group[i] });
                        if (c)
                        {
                            var tempArray = [];
                            for (var idx in tmpGroup)
                            {
                                var vk = tmpGroup[idx];
                                var n = Array.find(groupPosition, function (el) { return el.ViewKey == vk });
                                if (n)
                                {
                                    tempArray.push(n);
                                }
                            }
                            var m = Array.find(tempArray, function (el) { return el.Position == c.Position });
                            if (m == null)
                            {
                                tmpGroup.push(in_group[i]);
                                subGroups.push(tmpGroup);
                            }
                        }
                    }
                }
            }
        }
        return subGroups;
    };

    /* jshint maxcomplexity: 5 */
    var getSortedLines = function (lines, racecardInfo)
    {
        //Primary sort by Odds, secondary sort by horse number
        var res = Array.getValues(lines);
        res.sort(chainSort(
            function (l1, l2)
            { //Sort by SP or not
                var l1sp = (l1.LineTypeID == 24 && l1.Odds == 0 ? 1 : 0);
                var l2sp = (l2.LineTypeID == 24 && l2.Odds == 0 ? 1 : 0);

                if (l1sp > l2sp) return 1;
                if (l1sp < l2sp) return -1;
                return 0;
            },
            function (l1, l2)
            { //Sort by odds
                if (l1.Odds > l2.Odds) return 1;
                if (l1.Odds < l2.Odds) return -1;
                return 0;
            },
            function (l1, l2)
            { //Sort by horse nbr (if available)
                var rc1 = racecardInfo[l1.ID];
                var rc2 = racecardInfo[l2.ID];
                if (rc1 && rc2)
                {
                    if (rc1.HorseNumber > rc2.HorseNumber) return 1;
                    if (rc1.HorseNumber < rc2.HorseNumber) return -1;
                }
                return 0;
            }
        ));

        return res;
    }

    /* jshint maxcomplexity: 5 */
    api.isEmptyDepositObject = function (obj)
    {
        for (var prop in obj)
        {
            if (Object.prototype.hasOwnProperty.call(obj, prop) && obj[prop] > 0)
            {
                return false;
            }
        }
        return true;
    }

    api.getBetLoyaltyPoints = function (purchData, bet)
    {
        return Array.find(purchData.LoyaltyPointsPromotions, function (promotion) { return promotion.BetID == bet.BetID });
    };

    api.isRelatedBet = function (purchData, bet)
    {
        return typeof bet.RelatedToID !== 'undefined' && hasAnyRelatedBets(purchData, bet);
    };

    var hasAnyRelatedBets = function (purchData, bet)
    {
        return purchData.Bets.any(function (b) { return b.BetID === bet.RelatedToID });
    };

    api.shouldUpdateBetsCounter = function (purchData, bet)
    {
        return !bet.IsEachWay && hasAnyRelatedBets(purchData, bet);
    };

    api.getLoyaltyPoints = function (placedBet, isEachWayBet)
    {
        if (isEachWayBet)
        {
            return placedBet.EWLoyaltyPointsPromotions;
        }
        else
        {
            return placedBet.LoyaltyPointsPromotions;
        }
    };

    api.addLoyaltyPointsForEWBets = function (bets, bet)
    {
        //searching in already created bets because main bet is always before those related to it
        var relatedBet = bets.find(function (b) { return b.BetID === bet.RelatedToID });
        relatedBet.EWLoyaltyPointsPromotions = bet.LoyaltyPointsPromotions;
    };

    api.setEWLoyaltyPoints = function (bets, betData)
    {
        if (betData.IsEachWay)
        {
            BetSlipUtil.addLoyaltyPointsForEWBets(bets, betData);
        }
    };


    api.getLineType = function ()
    {
        return BetSlip.CurrentMode.SelectionDrawType;
    };

    api.getSelectionType = function (selection)
    {
        switch (true)
        {
            case (selection instanceof RegularSlipSelection || selection instanceof RegularLiveSlipSelection):
                return 'regularSelection';
            case (selection instanceof MultiLineItem):
                return 'multiLineSelection';
            case (selection instanceof QASlipSelection || selection instanceof QALiveSlipSelection):
                return 'QASelection';
            default:
                return false;
        }
    };

    api.hasEachWay = function (selection, mode, context)
    {
        if (typeof BetSlipRegulations !== 'undefined' && BetSlipRegulations.hasOwnProperty('HideEachWay') && BetSlipRegulations.HideEachWay == true)
        {
            return false;
        }
        return (context.isPurchase || !Modes.isSingleMode(mode) || !selection.IsEachWayEnabled || Modes.isCombinatorMode(mode)) ? false : true;
    };

    api.getSelectionEachWayIncluded = function (selection, context)
    {
        var selectionEachWayIncluded = false;
        if (IsUKBetSlip)
        {
            selectionEachWayIncluded = context.isPurchase ?
                                       selection.EachWaySingleIncluded || (context.shouldShowEW && selection.EachWayMultiplesIncluded) :
                                       selection.EachWaySingleIncluded || selection.EachWayMultiplesIncluded;
        }
        else
        {
            selectionEachWayIncluded = selection.EachWayIncluded;
        }

        return selectionEachWayIncluded;
    };

    api.isVirtualSport = function (branchID)
    {
        return branchID === eBranches.VirtualSports;
    };

    api.getPickLineOdds = function (mode, selection, context, skipEW)
    {
        var odds = Selections.getFormattedOdds(mode, selection, context);

        if (context.isPurchase && Selections.isEachwayIncluded(mode, selection, context) && !skipEW)
        {
            odds = Selections.getFormattedOddsEW(mode, selection, context);
        }

        return odds;
    };

    api.getQAOdds = function (mode, selection, context, spOptions)
    {
        var odds = Selections.getFormattedOdds(mode, selection, context);

        if (spOptions.second == 0)
        {
            spOptions.second = 'SP';
        }

        return odds;
    };

    api.hasOverlay = function (mode, selection)
    {
        var hasOverlay = selection.Error && (selection.Danger || selection.LineClosed || !selection.Valid);

        if (!Modes.isCombinatorMode(mode) && selection.ComboBetIsEnabled === undefined)
        {
            hasOverlay = hasOverlay && selection.ComboBetIsEnabled;
        }

        if (BetSlip.isComboNoCombinationSingleMode())
        {
            hasOverlay = !selection.ComboBetIsEnabled && BetSlip.getSelectionsCount() > 1;
        }

        return hasOverlay;
    };

    api.notBuildComboOptions = function (mode, selections)
    {
        return Object.keys(selections).length === 0 ||
            (BetSlip.isComboNoCombinationSingleMode(mode) && Object.keys(selections).length > 1 && Array.getLength(mode.getSelectionsInCombo()) === 0);
    };

    api.notBuildUKMultiplesOptions = function (selections)
    {
        return Object.keys(selections).length === 0 || BetSlip.getSelectionsCount() < 2;
    };

    api.shouldBuildQuickStake = function (mode)
    {
        return (mode instanceof ComboNoCombinationSPSlipMode || Modes.isComboNoCombinationSingleMode(mode)) && QuickStake.isAvailable();
    };

    api.buildCheckBoxContextForMultiOptions = function (mode, options, type)
    {
        var context = {};
        var checkedClass = getIsChecked(mode, options);

        if (type == 'default')
        {
            if ((typeof ComboSPSlipMode !== 'undefined' && mode instanceof ComboSPSlipMode) ||
                (typeof ComboSlipMode !== 'undefined' && mode instanceof ComboSlipMode) ||
                (typeof ComboNoCombinationSPSlipMode !== 'undefined' && mode instanceof ComboNoCombinationSPSlipMode) ||
                 Modes.isComboNoCombinationSingleMode(mode))
            {

                context.id = api.getDefaultEachWayBoxID(options);
                context.onClick = 'UniSlipBlock.updateEachWay({0})'.format(options.key);
            }

            if ((typeof SystemSPSlipMode !== 'undefined' && mode instanceof SystemSPSlipMode) ||
                (typeof SystemSlipMode !== 'undefined' && mode instanceof SystemSlipMode))
            {
                context.id = api.getDefaultEachWayBoxID(options);
                context.onClick = 'UniSlipBlock.updateEachWay(this)';
            }
        }
            //UK
        else if (type == 'uk')
        {
            if ((options.ukSubMode == UKSlipModeSubModes.System && mode.SelectedSystemEWVariants[options.key]) ||
                (options.ukSubMode != UKSlipModeSubModes.System && mode.CheckForEachWayIncluded(options.key, true)))
            {
                checkedClass = 'checked';
            }

            if (typeof UKSPSlipMode !== 'undefined' && mode instanceof UKSPSlipMode)
            {
                context.id = api.getUKEachWayBoxID(options);
                var ukSubMode = options.ukSubMode == UKSlipModeSubModes.System ? UKSlipModeSubModes.System : UKSlipModeSubModes.Combo;
                context.onClick = 'UniSlipBlock.updateEachWay(' + options.key + ',' + ukSubMode + ')';
            }
        }

        context.checked = checkedClass;

        return context;
    };

    api.getDefaultEachWayBoxID = function (options)
    {
        return 'eachWayOpt-' + options.key;
    };

    api.getUKEachWayBoxID = function (options)
    {
        return 'eachWayOpt-' + (options.systemName ? 'system' : 'combo') + '-' + options.key;
    };

    var getIsChecked = function (mode, options)
    {
        switch (true)
        {
            //Combo
            case (((typeof ComboSPSlipMode !== 'undefined' && mode instanceof ComboSPSlipMode) ||
                  (typeof ComboNoCombinationSPSlipMode !== 'undefined' && mode instanceof ComboNoCombinationSPSlipMode) ||
                  Modes.isComboNoCombinationSingleMode(mode)) && Modes.isMultiEWVariantChecked(mode, options.key)) ||
                (typeof ComboSlipMode !== 'undefined' && mode instanceof ComboSlipMode && Modes.isMultiEWVariantChecked(mode, options.key)):
                return 'checked';
                //System
            case (typeof SystemSPSlipMode !== 'undefined' && mode instanceof SystemSPSlipMode && options.ewIncluded):
                return 'checked';
            default:
                return '';
        }
    };

    api.getComboStakeBoxID = function (options)
    {
        return IsUKBetSlip ? 'stakebox_combo_' + options.key : 'stakebox_' + options.key;
    };

    api.getSystemStakeBoxID = function (options)
    {
        return IsUKBetSlip ? 'stakebox_system_' + options.key : 'stakebox_system';
    };

    api.hideSelectionCheckbox = function (selection, mode)
    {
        return !selection.ComboRate || BetSlip.ShowBetCheckBoxes === 0 || Modes.isCombinatorMode(mode);
    };

    api.isSingleSelection = function (selectionCount)
    {
        return selectionCount === 1 && BetSlip.TemplateType === 2;
    };

    api.showComboBonusInfo = function (mode, key)
    {
        return ComboBonusProvider.ComboBonuses && ComboBonusProvider.ComboBonuses[key] && !mode.EachWayIncluded && !mode.NamedSystemOdds[key];
    };

    api.hideBuyPointsSelect = function (mode)
    {
        return (typeof TeaserSPSlipMode !== "undefined" && mode instanceof TeaserSPSlipMode);
    }

    return api;
}()));